import React, { useEffect } from "react";
import AttendanceView from "../../components/admin/AttendanceView";

const AttendanceViewPage = () => {

   useEffect(() => {
          document.body.id = "attendanceview-002";
        }, []);
  return (
    <div>
     <AttendanceView /> 
    </div>
  );
};

export default AttendanceViewPage;
